export function I18nBuilder(prefix, data) {
  this.data = data || {};
  this.prefix = prefix;

  this.add = function(key, callback) {
    const newPrefix = this.prefix + "_" + key;
    if (callback) {
      this.data[key] = {};
      callback(new I18nBuilder(newPrefix, this.data[key]));
    } else {
      this.data[key] = newPrefix;
    }
    return this;
  };

  this.getData = function() {
    return this.data;
  };

  this.getKeysFrom = function(nestedData) {
    const result = [];
    Object.keys(nestedData).forEach(property => {
      const value = nestedData[property];
      if (typeof value === "string" || value instanceof String) {
        result.push(value);
      } else {
        result.push(...this.getKeysFrom(value));
      }
    });
    return result;
  };

  this.getKeys = function() {
    return this.getKeysFrom(this.data);
  };
}
